// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AuthorizeFilledSvg from "@fishx/icons-svg/es/asn/AuthorizeFilled";
import FishxIcon from '../components/FishxIcon';

var AuthorizeFilled = function AuthorizeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AuthorizeFilledSvg
  }));
};

AuthorizeFilled.displayName = 'AuthorizeFilled';
export default React.forwardRef(AuthorizeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AuthorizeFilled.js
// module id = 2035
// module chunks = 0